import React, { useState } from 'react';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { glassPanelSx, panelHeaderSx, panelTitleSx } from '../../styles/panels';

/**
 * Glass card with a clickable header that expands and collapses its body.
 *
 * @param actions rendered right-aligned in the header; clicks there do not collapse
 */
const CollapsiblePanel = ({ title, actions = null, defaultOpen = true, sx = {}, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Box sx={{ ...glassPanelSx, ...sx }}>
      <Box sx={panelHeaderSx(open)} onClick={() => setOpen((v) => !v)}>
        <IconButton
          size="small"
          aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
          sx={{ color: 'white', mr: 1.5 }}
        >
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>

        <Typography sx={panelTitleSx}>{title}</Typography>

        {actions && (
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}
            onClick={(e) => e.stopPropagation()}
          >
            {actions}
          </Box>
        )}
      </Box>

      <Collapse in={open}>{children}</Collapse>
    </Box>
  );
};

export default CollapsiblePanel;
